import { FC } from "react";
import { SvgIconComponent } from "@mui/icons-material";
import { Stack, Tab, TabProps, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { pageHeaderHeight } from "../../../common/PageHeader";

interface AutomationsHeaderTabProps extends Omit<TabProps, "icon"> {
  to: string;
  value: string;
  title: string;
  count: number;
  active: boolean;
  icon: SvgIconComponent;
}

export const AutomationsHeaderTab: FC<AutomationsHeaderTabProps> = ({
  to,
  value,
  count,
  title,
  active,
  icon: Icon,
  ...props
}) => {
  return (
    <Tab
      {...props}
      component={Link as any}
      to={to}
      icon={<Icon fontSize="small" />}
      iconPosition="start"
      label={
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="inherit">{title}</Typography>

          <Stack
            alignItems="center"
            width={24}
            height={24}
            borderRadius={10}
            justifyContent="center"
            bgcolor={active ? "primary.light" : "grey.100"}
          >
            <Typography color="inherit" fontWeight={500} fontSize={12}>
              {count}
            </Typography>
          </Stack>
        </Stack>
      }
      value={value}
      sx={tabStyles}
    />
  );
};

const paddingHeight = 2;
const tabStyles = {
  textTransform: "none",
  height: pageHeaderHeight - paddingHeight,
  minHeight: "inherit",
};
